import React from "react";
import { Link } from "react-router-dom";
import "./notfound.css";

export default function NotFound() {
  return (
    <div className="page notfound-page">
      <section className="panel notfound-panel">
        <h1>404</h1>
        <p>This page doesn’t exist.</p>
        <p><Link to="/">Go back home</Link></p>
      </section>
    </div>
  );
}